module.exports = __webpack_public_path__ + "img/icon314.0adfcaeb.png";